import { cn } from '@/lib/utils';

export const GoogleDriveIcon = ({ className, ...props }: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 87.3 78"
      className={cn('h-5 w-5', className)}
      {...props}
    >
      <path
        fill="#0066DA"
        d="M6.6 66.85l3.85 6.65c.8 1.4 1.95 2.5 3.3 3.3L29 52.2H0c0 1.55.4 3.1 1.2 4.5l5.4 10.15z"
      />
      <path
        fill="#00AC47"
        d="M43.65 25.15L29 1.2C27.65 2 26.5 3.1 25.7 4.5L1.2 46.5C.4 47.9 0 49.45 0 51h29l14.65-25.85z"
      />
      <path
        fill="#EA4335"
        d="M73.55 76.8c1.35-.8 2.5-1.9 3.3-3.3l1.6-2.75L86.1 57.7c.8-1.4 1.2-2.95 1.2-4.5H58.3L64 66.85l9.55 9.95z"
      />
      <path
        fill="#00832D"
        d="M43.65 25.15L58.3 1.2C57.5.4 56.55-.05 55.5-.05H31.8c-1.05 0-2.1.45-2.8 1.25l14.65 23.95z"
      />
      <path
        fill="#2684FC"
        d="M58.3 52.2H29l-15.25 24.6c.85.5 1.8.8 2.8.8h54.4c1 0 1.95-.3 2.8-.8L58.3 52.2z"
      />
      <path
        fill="#FFBA00"
        d="M73.4 26.5L61.65 4.5c-.8-1.4-1.95-2.5-3.3-3.3L43.65 25.15 58.3 51h29c0-1.55-.4-3.1-1.2-4.5L73.4 26.5z"
      />
    </svg>
  );
};
